import { Para, Stack } from '@drycut/ui-components';

import { ServicesSelection } from '../../../ServicesSelection';
import { useCheckoutStore } from '../../checkoutStore';

// The default selection (first/haircut service) is seeded by BookingCheckout itself, since this
// step isn't always rendered (eg. it's skipped for manual bookings with only one service).
export function ServicesStep(): React.ReactElement {
  const selectedStore = useCheckoutStore((state) => state.selectedStore);
  const selectedServices = useCheckoutStore((state) => state.selectedServices);
  const setSelectedServices = useCheckoutStore((state) => state.setSelectedServices);

  const services = selectedStore?.services ?? [];

  if (services.length === 0) {
    return (
      <Stack>
        <Para size="sm">Für diesen Salon sind keine Services verfügbar.</Para>
      </Stack>
    );
  }

  return (
    <ServicesSelection
      services={services}
      selectedServices={selectedServices}
      onServicesSelect={setSelectedServices}
    />
  );
}
